"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
const lodash_1 = require("lodash");
class Base {
    constructor(client) {
        this._client = client;
    }
    get(path, options) {
        let query = lodash_1.pick(options, ["domain", "ip", "webhookUrl", "webhookId"]);
        return this._client._request({
            method: "get",
            url: this._client._buildUrl(this.api, path, this.version),
            query: query,
            timeout: options.timeout || null,
        });
    }
}
exports.Base = Base;
//# sourceMappingURL=base.js.map